import React from "react";
import "./Footer.css";

import { Link } from "react-router-dom";
import logo1 from "../assets/foot-logo.png";
import img1 from "../assets/foot-icon1.png";

import img5 from "../assets/foot-icon5.png";
import img6 from "../assets/foot-icon6.png";
import img7 from "../assets/foot-icon7.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">

        {/* LEFT COLUMN */}
        <div className="footer-logo">
          <img src={logo1} alt="Sundaram Clayton Limited" />

          <div className="social-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
           <a href="https://www.linkedin.com/company/sundaram-clayton-limited" target="_blank" rel="noopener noreferrer">
      <img src={img1} alt="LinkedIn" />
    </a>
  </div>
</div>
        </div>

        {/* MIDDLE COLUMN */}
        <div className="footer-links">
          <h3>Quick Links</h3>
        <Link to="/">Home</Link>
<Link to="/disclaimer">Disclaimer</Link>
        </div>

        {/* RIGHT COLUMN */}
        <div className="footer-box">
          <h3>Registered Office</h3>

          <p>
            <img src={img5} alt="icon" />
           Chaitanya, No. 12, Khader Nawaz Khan Road, Nungambakkam, Chennai – 600006
          </p>

          <p>
            <img src={img6} alt="icon" />
            corpsec@sundaramclayton.com
          </p>

          <p>
            <img src={img7} alt="icon" />
            044 28332115
          </p>

          <p>Fax: 044 28332113</p>
          <p>CIN: L51001TN2017PLC118315</p>
        </div>

      </div>

      <div className="footer-bottom">
        Copyright 2026, Sundaram Clayton Limited. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
